import { render, staticRenderFns } from "./RankingItems.vue?vue&type=template&id=4c06bbe2&scoped=true&"
import script from "./RankingItems.vue?vue&type=script&lang=js&"
export * from "./RankingItems.vue?vue&type=script&lang=js&"
import style0 from "./RankingItems.vue?vue&type=style&index=0&id=4c06bbe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06bbe2",
  null
  
)

export default component.exports